import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton } from 'antd';
import styled, { css } from 'styled-components';
import { Text } from '../../../ui';
import { rem } from '../../../utils';
export const StyledCardLink = styled.a `
  width: 100%;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
`;
export const StyledImageWrapper = styled.div `
  ${({ theme, source, maxHeight = 'auto' }) => css `
    display: flex;
    width: 100%;
    height: auto;
    flex-direction: column;
    align-items: center;
    align-self: stretch;
    border-radius: ${rem(theme.Border.Radius.Medium)};
    overflow: hidden;

    img {
      width: auto;
      max-width: 100%;
      height: ${typeof maxHeight === 'string' ? 'auto' : rem(maxHeight)};
      border-radius: ${rem(theme.Border.Radius.Medium)};
    }
  `}
`;
export const StyledImageCardText = styled((props) => (_jsx(Text, Object.assign({}, props)))) `
  text-align: center;
`;
export const StyledImageCardSkeletonText = styled(Skeleton.Button) `
  &&& {
    height: 16px;
  }
`;
export const StyledWrapper = styled.div `
  ${({ theme, width, height, selected, disabled }) => css `
    background-color: ${theme.Components.Panel.Background};
    display: flex;
    ${width && `width: ${rem(width)}`};
    ${height && `width: ${rem(height)}`};
    padding: ${rem(theme.Spacing.Size.XSmall)};
    border-radius: ${rem(theme.Border.Radius.Large)};
    transition: box-shadow ${theme.Transition.Timing.Out};
    box-shadow: inset 0 0 0
      ${rem(selected ? theme.Border.Size.Medium : theme.Border.Size.Small)}
      ${selected ? theme.Color.Brand.Primary : theme.Color.Neutrals.Border};
    cursor: ${disabled ? 'initial' : 'pointer'};

    &:hover {
      box-shadow: ${disabled
    ? 'none'
    : `inset 0 0 0 ${rem(theme.Border.Size.Medium)} ${theme.Color.Brand.Primary}`};
      transition: box-shadow ${theme.Transition.Timing.In};
    }

    & .ant-image-mask {
      border-radius: ${rem(theme.Spacing.Size.Small)};
    }
  `}
`;
//# sourceMappingURL=ImageCard.style.js.map